var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { dependentKeyCompat } from '@ember/object/compat';
import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { htmlSafe } from '@ember/template';
function isAbsoluteUrl(url) {
  try {
    // This only succeeds for fully qualified URLs – relative URLs will throw
    new URL(url);
    return true;
  } catch {
    return false;
  }
}
let AssetMapService = (_class = class AssetMapService extends Service {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "assetHost", '');
    _defineProperty(this, "enabled", false);
    _defineProperty(this, "prepend", '/');
    _initializerDefineProperty(this, "map", _descriptor, this);
  }
  get fullMap() {
    const assetMap = {};
    Object.keys(this.map).forEach(k => {
      const v = this.map[k];
      assetMap[k] = v;
      assetMap[v] = v;
    });
    return assetMap;
  }

  // This differs from the stock implementation of ember-cli-ifa's assetMap.resolve() in two ways:
  // 1. It does *not* add the `prepend` value if the asset is not in the asset map. This allows us to use the
  //    {{asset-map}} helper everywhere, without needing to know whether we're passing a relative or absolute URL.
  // 2. It strips the leading slash, if present, because asset map keys do not have one.
  resolve(path) {
    if (!path) {
      return path;
    }
    const pathWithoutLeadingSlash = path.replace(/^\//, '');
    if (!this.enabled) {
      return isAbsoluteUrl(path) ? path : `${this.prepend}${pathWithoutLeadingSlash}`;
    }
    const fingerprintedName = this.fullMap[pathWithoutLeadingSlash];
    if (fingerprintedName) {
      return `${this.assetHost}${this.prepend}${fingerprintedName}`;
    }

    // Handle URLs that have already been fingerprinted and had /dashboard/ prepended by broccoli-asset-rev
    if (path.startsWith(this.prepend)) {
      return `${this.assetHost}${path}`;
    }
    return path;
  }
  resolveSrcset(srcset) {
    const imageCandidateStrings = srcset.split(',');
    return imageCandidateStrings.map(imageCandidateString => {
      const [url, descriptor] = imageCandidateString.trim().split(' ');
      return descriptor ? `${this.resolve(url)} ${descriptor}` : this.resolve(url);
    }).join(', ');
  }
  resolveBackgroundImage(path) {
    if (!path) {
      return htmlSafe('');
    }
    if (path.startsWith('data:')) {
      // don't re-encode a data url
      return htmlSafe(`background-image: url("${path}");`);
    }
    const resolvedPath = this.resolve(path);
    return htmlSafe(`background-image: url("${encodeURI(resolvedPath)}");`);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "map", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, "fullMap", [dependentKeyCompat], Object.getOwnPropertyDescriptor(_class.prototype, "fullMap"), _class.prototype), _class);
export { AssetMapService as default };